import type {AppStore} from "modules/app/state/app";
import {snackbarErrorGeneratingHelper} from "modules/common/providers/FluxSnackbarProvider";

export function enqueueSyncErrorNotification(message: string, showSyncErrors: boolean, appStore: AppStore): void {
    if (showSyncErrors) {
        const appState = appStore.getState();
        appState.toggleEditorBackdrop(true);
        appState.enqueueNotification(snackbarErrorGeneratingHelper(message), "project", {
            variant: "error",
            preventDuplicate: true,
            persist: true,
            key: "syncError2",
        });
    }
}
